import { useQuery } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { withdrawalCheck } from "src/service/sessions";
import { IWithdrawalCheckRes } from "src/service/types/sessions.type";

// 회원 탈퇴 가능 여부 체크
export function useWithdrawalCheck() {
  const { handleError } = useApiError();

  const { isLoading: withdrawalCheckLoading, data } =
    useQuery<IWithdrawalCheckRes>(["withdrawalCheck"], withdrawalCheck, {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onError: handleError,
    });

  return {
    withdrawalCheckLoading,
    withdrawable: data?.withdrawable ?? false,
  };
}
